import type { EnergyLabelData } from './EnergyLabel.types';

import useReactRouting from '../../hooks/useReactRouting';
import styles from './EnergyLabel.module.scss';
import { getEnergyLabelLinkAriaLabel, getProductUrlWithOpenEnergyLabel } from './EnergyLabel.utils';
import EnergyLabelBadgeImage from './EnergyLabelBadgeImage';
import EnergyLabelProductSheetLink from './EnergyLabelProductSheetLink';
import { useIsNewEnergyLabelsEnabled } from './useIsNewEnergyLabelsEnabled';

const EnergyLabelContent = ({
    energyLabel,
    productUrl,
    size = 'default',
}: {
    energyLabel: EnergyLabelData | undefined;
    productUrl: string;
    size?: 'small' | 'default';
}) => {
    const { push } = useReactRouting();
    const isNewEnergyLabelsEnabled = useIsNewEnergyLabelsEnabled();

    if (!energyLabel) {
        return null;
    }

    const badgeImage = (
        <EnergyLabelBadgeImage
            energyLabel={energyLabel}
            size={size}
            alt={isNewEnergyLabelsEnabled ? '' : energyLabel.accessibilityText}
        />
    );

    if (!isNewEnergyLabelsEnabled) {
        return (
            <div className={styles.Block}>
                <span className={styles.Badge}>{badgeImage}</span>
                <EnergyLabelProductSheetLink productSheetUrl={energyLabel.productSheetUrl} />
            </div>
        );
    }

    const href = getProductUrlWithOpenEnergyLabel(productUrl);

    return (
        <div className={styles.Block}>
            <a
                href={href}
                className={styles.BadgeLink}
                aria-label={getEnergyLabelLinkAriaLabel(energyLabel.energyClass)}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    push(href);
                }}
            >
                {badgeImage}
            </a>
            <EnergyLabelProductSheetLink productSheetUrl={energyLabel.productSheetUrl} />
        </div>
    );
};

export default EnergyLabelContent;
